export default {
  tabs: {
    gift_cards: 'Geschenkkarten',
    settings: 'Einstellungen',
  },
  gift_cards: {
    title: 'Geschenkkarten',
    subtitle: 'Verwalte alle Geschenkkarten für dein Restaurant',
    buttons: {
      create: 'Geschenkkarte erstellen',
      redeem: 'Gutschein einlösen',
      check_balance: 'Guthaben prüfen',
    },
    search: {
      placeholder: 'Suchtext eingeben',
    },
    columns: {
      code: 'Code',
      status: 'Status',
      balance: 'Guthaben',
      value: 'Wert',
      email: 'Käufer',
      source: 'Quelle',
      created_at: 'Erstellt',
    },
    statuses: {
      active: 'Aktiv',
      partially_redeemed: 'Teilweise eingelöst',
      redeemed: 'Eingelöst',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Geschenkkarten-Einstellungen',
      subtitle: 'Konfiguriere die Geschenkkarten-Optionen für dein Restaurant',
      availability: {
        title: 'Geschenkkarten aktivieren',
        subtitle: 'Ermögliche es deinen Kunden, Geschenkkarten zu kaufen und einzulösen',
        buttons: {
          enable: 'Aktivieren',
          disable: 'Deaktivieren',
        },
      },
    },
    redemption_options: {
      title: 'Einlöseoptionen',
      subtitle: 'Wählen Sie aus, wo Kund:innen Geschenkkarten einlösen können',
      redemption_mode: {
        title: 'Einlösemodus',
        subtitle: 'Dies beeinflusst den Text auf Ihrer Geschenkkarten-Landingpage',
        buttons: {
          online: 'Nur online',
          online_and_store: 'Online & im Geschäft',
        },
      },
    },
  },
  summary: {
    total_value: 'Gesamtwert',
    total_active: 'Gesamt aktiv',
    redeemed_this_month: 'Diesen Monat eingelöst',
  },
};
